import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { querySystemNotice, updateIsReadFlowableRecord, queryMessageFlowableRecordById } from '@/api/dashboard/systemnotifi.js';
import { queryIsDelayDocument } from '@/api/notice/documentApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '功能模块',
      dataIndex: 'noticeType',
      align: 'center',
      width: 5,
      scopedSlots: {
        customRender: 'noticeType'
      }
    }, {
      title: '消息类型',
      dataIndex: 'msgType',
      align: 'center',
      width: 5,
      scopedSlots: {
        customRender: 'msgType'
      }
    }, {
      title: '标题',
      dataIndex: 'fileName',
      ellipsis: false,
      align: 'center',
      resizable: true,
      width: 20
    }, {
      title: '描述',
      dataIndex: 'msgContent',
      ellipsis: false,
      align: 'center',
      resizable: true,
      width: 30
    }, {
      title: '接收日期',
      dataIndex: 'msgTime',
      ellipsis: true,
      align: 'center',
      width: 10
    }, {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: 5,
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 5,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      pagination: this.$hdk.page(),
      // pagination: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize)
      // },
      expand: false,
      formState: {
        title: '',
        serialNumber: '',
        noticeType: undefined,
        node: '',
        status: undefined,
        time: [],
        startDate: '',
        endDate: '',
        msgType: undefined
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  created: function created() {
    this.fetch();
  },
  methods: {
    newViewAudit: function newViewAudit(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        isEmergent: row.isEmergent,
        tempId: row.tempId,
        docStatus: row.fillStatus,
        auditStep: row.auditStep
      };
      localStorage.removeItem('data');
      localStorage.setItem('data', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'reView',
          data: req
        }
      });
    },
    /**
     * 报销审批跳转
     */
    auditReimburse: function auditReimburse(row) {
      if (row.auditStatus == null) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.fileId,
            type: 2
          }
        });
      }
    },
    /**
     * 表单审批跳转
     */
    formApproval: function formApproval(row) {
      var _this = this;
      if (row.auditStatus == null) {
        queryMessageFlowableRecordById(row.msgId).then(function (res) {
          _this.$router.push({
            path: '/formReview/reviewCenter/auditProcess',
            query: {
              procInsId: row.bizId,
              taskId: res.data.data.taskId,
              path: 'waitMeApplication'
            }
          });
        });
      }
    },
    /**
     * 跳转至报修审核页面
     */
    toRepairsDetail: function toRepairsDetail(row) {
      if (row.fillStatus == 1 || row.fillStatus == 2) {
        this.$router.push({
          path: '/reimburseRepairs/repairs/repairsDetail',
          query: {
            id: row.fileId,
            mode: 'accept',
            backTo: 'system',
            repairsStatus: row.fillStatus
          }
        });
      } else if (row.fillStatus == 3) {
        this.$router.push({
          path: '/reimburseRepairs/repairs/repairsDetail',
          query: {
            id: row.fileId,
            mode: 'order',
            backTo: 'system',
            repairsStatus: row.fillStatus
          }
        });
      } else if (row.fillStatus == 7) {
        this.$router.push({
          path: '/reimburseRepairs/repairs/repairsDetail',
          query: {
            id: row.fileId,
            mode: 'evaluation',
            backTo: 'system',
            repairsStatus: row.fillStatus
          }
        });
      }
    },
    /**
     * 初核跳转
     */
    firstTrial: function firstTrial(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'firstTrial',
          data: req
        }
      });
    },
    /**
     * 复核跳转
     */
    reCheck: function reCheck(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'reCheck',
          data: req
        }
      });
    },
    /**
     * 会签跳转
     */
    groupSign: function groupSign(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'groupSign',
          data: req
        }
      });
    },
    /**
     * 签发跳转
     */
    signIssue: function signIssue(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'signIssue',
          data: req
        }
      });
    },
    /**
     * 校对跳转
     */
    proofread: function proofread(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'proofread',
          data: req
        }
      });
    },
    /**
     * 打印跳转
     */
    printClick: function printClick(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        tempId: row.tempId,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          data: req,
          mode: 'print'
        }
      });
    },
    /**
     * 展开折叠状态
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    /**
     *点击查询时触发
     */
    search: function search() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      if (this.formState.status == 0 || this.formState.status == 1) {
        this.formState.msgType = 1;
      } else if (this.formState.status == 2 || this.formState.status == 3) {
        this.formState.msgType = 2;
      }
      this.fetch();
    },
    /**
     * 根据条件进行查找数据
     *
     */
    fetch: function fetch(options) {
      var _this2 = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startDate = this.formState.time[0];
        this.formState.endDate = this.formState.time[1];
      } else {
        this.formState.startDate = null;
        this.formState.endDate = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      querySystemNotice(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this2.list = res.data.data.rows;
        _.assign(pagination, {
          total: res.data.data.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    //跳转至审批页面
    viewAudit: function viewAudit(row) {
      if (row.noticeType == 3) {
        if (row.cateId === 1) {
          this.$router.push({
            path: '/reimburseRepairs/myReimburse/travelApproval',
            query: {
              fillId: row.fileId,
              type: 2,
              path: 'system'
            }
          });
        } else if (row.cateId === 2) {
          this.$router.push({
            path: '/reimburseRepairs/myReimburse/expenseApproval',
            query: {
              fillId: row.fileId,
              type: 2,
              path: 'system'
            }
          });
        }
      } else {
        this.$router.push({
          path: '/docNotice/notice/auditNotice',
          query: {
            id: row.fileId,
            type: 2,
            path: 'system'
          }
        });
      }
    },
    /**
     * 判断点击查看时跳转页面
     */
    view: function view(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, req, _res, _req;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(row.noticeType == 1)) {
                _context.n = 1;
                break;
              }
              _this3.$router.push({
                path: '/docNotice/notice/noticeAdd',
                query: {
                  id: row.fileId,
                  type: 2,
                  msgId: row.msgId,
                  noticeType: row.noticeType,
                  look: 'updateWorkbench',
                  looks: 'editSystemNoticeState'
                }
              });
              //公文流转
              _context.n = 9;
              break;
            case 1:
              if (!(row.noticeType == 2)) {
                _context.n = 8;
                break;
              }
              if (!(row.msgType == 1)) {
                _context.n = 4;
                break;
              }
              _context.n = 2;
              return queryIsDelayDocument({
                docId: row.fileId
              });
            case 2:
              res = _context.v;
              if (!(res.data.data === 1)) {
                _context.n = 3;
                break;
              }
              _this3.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 3:
              req = {
                id: row.fileId,
                type: row.noticeType,
                msgId: row.msgId,
                look: 'editSystemNoticeState'
              };
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(req));
              _this3.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: req,
                  backto: 'put'
                }
              });
              _context.n = 7;
              break;
            case 4:
              _context.n = 5;
              return queryIsDelayDocument({
                docId: row.fileId
              });
            case 5:
              _res = _context.v;
              if (!(_res.data.data === 1)) {
                _context.n = 6;
                break;
              }
              _this3.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 6:
              _req = {
                id: row.fileId,
                auditId: row.bizId,
                tempId: row.tempId,
                docStatus: row.fillStatus
              };
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(_req));
              _this3.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: _req,
                  backto: 'deal'
                }
              });
            case 7:
              _context.n = 9;
              break;
            case 8:
              if (row.noticeType == 3) {
                if (row.cateId === 1) {
                  _this3.$router.push({
                    path: '/reimburseRepairs/myReimburse/travelApproval',
                    query: {
                      fillId: row.fileId,
                      type: 1,
                      path: 'system'
                    }
                  });
                } else if (row.cateId === 2) {
                  _this3.$router.push({
                    path: '/reimburseRepairs/myReimburse/expenseApproval',
                    query: {
                      fillId: row.fileId,
                      type: 1,
                      path: 'system'
                    }
                  });
                }
              } else if (row.noticeType == 4) {
                /**
                 * 点击查看跳转
                 */
                _this3.$router.push({
                  path: '/reimburseRepairs/repairs/repairsDetail',
                  query: {
                    id: row.fileId,
                    mode: 'view',
                    backTo: 'system',
                    repairsStatus: row.fillStatus
                  }
                });
              } else if (row.noticeType == 5) {
                if (row.msgType == 1) {
                  updateIsReadFlowableRecord(row.msgId).then(function (res) {
                    _this3.$router.push({
                      path: '/formReview/reviewCenter/viewProcess',
                      query: {
                        procInsId: row.bizId
                      }
                    });
                  });
                } else if (row.msgType == 2) {
                  _this3.$router.push({
                    path: '/formReview/reviewCenter/viewProcess',
                    query: {
                      procInsId: row.bizId
                    }
                  });
                }
              }
            case 9:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {}
};